import { Component, OnInit } from '@angular/core';
import {RouterLink, RouterLinkActive} from "@angular/router";
import { UserInfoVO } from "@core/api/v1";
import { LoginService } from "@core/services/login/login.service";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";

@Component({
  selector: 'app-user-navigation',
  standalone: true,
    imports: [
        RouterLink,
        RouterLinkActive,
        FaIconComponent
    ],
  templateUrl: './user-navigation.component.html',
  styleUrl: './user-navigation.component.scss'
})
export class UserNavigationComponent implements OnInit {
    loggedInUser: UserInfoVO;
    name: string;

    constructor(private loginService: LoginService) {
    }

    logout() {
        this.loginService.logout();
    }

    ngOnInit() {
        this.holeUser();
        this.setName();

        this.loginService.isRefreshed.subscribe(response => {
            this.holeUser();
            this.setName();
        });
    }

    setName() {
        this.name =  [this.loggedInUser.vorgestellterTitel, this.loggedInUser.vorname, this.loggedInUser.nachname]
            .filter(Boolean) // Entfernt alle null und undefined
            .join(" ");

        if (this.loggedInUser.nachgestellterTitel) {
            this.name = this.name + " " + this.loggedInUser.nachgestellterTitel!;
        }
    }

    holeUser() {
        this.loggedInUser = this.loginService.holeEingeloggtenUser();
    }

}
